import { FC } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';

/**
 * Propsの型定義
 * @param title タイトル
 * @param jobCount 求人件数
 * @param url 遷移先URL
 * @param isBold 太文字フラグ
 * @param size テキストサイズ
 */
interface Props {
  title: string;
  jobCount: string;
  url?: string | null;
  isBold?: boolean;
  size?: 'L' | 'S';
}

// rel='nofollow'付加対象の件数
const ADD_NOFOLLOW_COUNT: string = '1';

export const DrillDownText: FC<Props> = ({
  title,
  jobCount,
  url,
  isBold,
  size = 'S',
}) => {
  if (url) {
    return (
      <div className={styles.drillDownText__title}>
        <a
          href={url}
          className={classnames(
            styles.drillDownText__title__text,
            styles['-anchor'],
            { [styles['-large']]: size === 'L' },
            { [styles['-small']]: size === 'S' },
            { [styles['-bold']]: isBold }
          )}
          rel={jobCount === ADD_NOFOLLOW_COUNT ? 'nofollow' : undefined}
        >
          {title}
        </a>
        <span className={styles.drillDownText__title__count}>({jobCount})</span>
      </div>
    );
  }
  return (
    <div className={styles.drillDownText__title}>
      <span
        className={classnames(
          styles.drillDownText__title__text,
          { [styles['-bold']]: isBold },
          { [styles['-large']]: size === 'L' },
          { [styles['-small']]: size === 'S' }
        )}
      >
        {title}
      </span>
      <span className={styles.drillDownText__title__count}>({jobCount})</span>
    </div>
  );
};
